import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";

  var get = "/provinsi";
  var post = "/provinsi";
    export const actGetDataProvinsi = () => {
      return (dispatch) => {
        let config = CONFIG_({ url: get, method: "GET" });
        dispatch({ type: "LOADING_PROVINSI_PROVISI" });
        CONNECTION(config)
          .then((response) => {
            const { status, data} = response;
            if (status === 200) {
              return dispatch({ type: "SUCCESS_PROVINSI_PROVISI", message: "Success get data", data:data, code:status});
            }
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "failed" });
          })
          .catch((response) => {
            console.log(response);
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "Network error.." });
          });

      };
    };
    
    export const actPostDataProvinsi = (params) => {
      return (dispatch) => {
        let config = CONFIG_({ url: post, data:params, method: "POST" });
        dispatch({ type: "LOADING_PROVINSI_PROVISI" });
        CONNECTION(config)
          .then((response) => {
            const { status } = response;
            if (status === 201) {
              return dispatch({ type: "SUCCESS_PROVINSI_PROVISI", message: "Success post data" });
            }
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "failed" });
          })
          .catch((response) => {
            console.log(response);
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "Network error.." });
          });
      };
    };
    
    export const actUpdateDataProvinsi = (params) => {
      return (dispatch) => {
        const {id} = params
        let config = CONFIG_({ url: post+'/'+id, data:params, method: "PUT" });
        dispatch({ type: "LOADING_PROVINSI_PROVISI" });
        CONNECTION(config)
          .then((response) => {
            const { status } = response;
            if (status === 200) {
              return dispatch({ type: "SUCCESS_PROVINSI_PROVISI", message: "Success put data" });
            }
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "failed" });
          })
          .catch((response) => {
            console.log(response);
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "Network error.." });
          });
      };
    };
    
    export const actDetailDataProvinsi = (params) => {
      return (dispatch) => {
        const {id} = params
        let config = CONFIG_({ url: post+'/'+id, method: "GET" });
        dispatch({ type: "LOADING_PROVINSI_PROVISI" });
        CONNECTION(config)
          .then((response) => {
            const { status } = response;
            if (status === 200) {
              return dispatch({ type: "SUCCESS_PROVINSI_PROVISI", message: "Success get data" });
            }
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "failed" });
          })
          .catch((response) => {
            console.log(response);
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "Network error.." });
          });
      };
    };

        export const actDeleteDataProvinsi = (params) => {
      return (dispatch) => {
        const {id} = params
        let config = CONFIG_({ url: post+'/'+id, method: "DELETE" });
        dispatch({ type: "LOADING_PROVINSI_PROVISI" });
        CONNECTION(config)
          .then((response) => {
            const { status } = response;
            if (status === 200) {
              return dispatch({ type: "SUCCESS_PROVINSI_PROVISI", message: "Success get data" });
            }
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "failed" });
          })
          .catch((response) => {
            console.log(response);
            return dispatch({ type: "ERROR_PROVINSI_PROVISI", message: "Network error.." });
          });
      };
    };